<template>
  <a-modal
    title="新建用户"
    :width="1280"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="12">
            <a-form-item label="系统账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'user_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="本系统登录用户名"
                :default-active-first-option="false"
                @search="this.userSearch"
                @change="handleUserChange"
              >
                <a-select-option v-for="d in userList" :key="d.id" :tt="d.username">
                  {{ d.username }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['name', {rules: [{required: true, message: '请输入'}, {min:2, max:10, message: '输入不符合长度限制'}]}]"
                placeholder="用户真实姓名"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['email', {rules: [{required: false, message: '请输入'}, {max:48, message: '输入不符合长度限制'}]}]" placeholder="邮箱"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['cell_phone1', {rules: [{required: false, message: '请输入'}, {max:20, message: '输入不符合长度限制'}]}]" placeholder="手机号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备用手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['cell_phone2', {rules: [{required: false, message: '请输入'}, {max:20, message: '输入不符合长度限制'}]}]" placeholder="备用手机号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="办公地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['office_location', {rules: [{required: false, message: '请输入'}, {max:255, message: '输入不符合长度限制'}]}]" placeholder="办公地点" :rows="1"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="OA Code" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oa_code', {rules: [{required: false, message: '请输入'}, {max:32, message: '输入不符合长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金蝶编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['jd_code', {rules: [{required: false, message: '请输入'}, {max:64, message: '输入不符合长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
// 表单字段
import debounce from 'lodash/debounce'
import { user_list } from '@/api/user'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.userSearch = debounce(this.handleUserSearch, 800)
    return {
      userList: [],
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 6 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleUserSearch (value) {
      user_list({ username: value }).then((res) => {
        const result = res.data.entries || []
        this.userList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleUserChange (value) {
      if (value === undefined) {
        this.handleUserSearch(value)
      }
    }
  }
}
</script>
